<template>
  <b-card no-body>
    <b-card-body>
      <customer-user-detail
        ref="customerUserDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerUserDetail from '@/views/pages/customers/CustomerUserDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerUserDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },
  created() {
    const id = this.$route.params.user_id;
    this.id = id;
    this.getUserData(id);
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editCustomerUser(this.id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'customers_user_list', params: { id: this.$route.params.id } });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getUserData(id) {
      this.submitting = true;
      useService
        .getUser(id)
        .then(response => {
          this.data = response.data;

          const { firstname, lastname, email, status, roles } = response.data;

          this.data = {
            firstname,
            lastname,
            email,
            status,
            role: roles && roles.length > 0 ? roles[0] : ''
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
